import { BaseUrlParamsFilter, BaseUrlParamsFilterProps } from 'entities/filters/base-url-params-filter';
import { Field, FieldProps } from 'formik';
import { Box, Chip, Typography } from '@mui/material';

type MetaFiltrableItemsProps = {
  items: { id: number; name: string; count: number }[];
  readOnly: boolean;
  queryParamName: string;
};

const MetaFiltrableItems = ({
  items,
  queryParamName,
  field,
  form: { setFieldValue },
  readOnly
}: MetaFiltrableItemsProps & FieldProps) => {
  const normalizeIds = (value: unknown) => {
    const toId = (raw: unknown) => {
      if (typeof raw === 'number') return Number.isFinite(raw) ? raw : null;
      const str = String(raw ?? '').trim();
      if (!str) return null;
      const num = Number(str);
      return Number.isFinite(num) ? num : null;
    };

    const filterIds = (ids: Array<unknown>) => ids.map(toId).filter((id): id is number => id !== null);

    if (Array.isArray(value)) return filterIds(value);
    if (typeof value === 'string') return filterIds(value.split(','));
    if (typeof value === 'number') return filterIds([value]);
    return [];
  };

  const formValue = field.value || [];
  const selectedIds = normalizeIds(formValue);

  const handleSelect = (id: number) => {
    const nextValue = selectedIds.includes(id)
      ? selectedIds.filter((i) => i !== id)
      : [...selectedIds, id];
    setFieldValue(queryParamName, nextValue);
  };

  const selectedStyle = { backgroundColor: 'primary.light', color: 'white' };

  return (
    <>
      {items.map((item) => {
        const isSelected = selectedIds.includes(item.id);
        return (
          <Box
            sx={{ cursor: readOnly ? 'default' : 'pointer' }}
            key={item.id}
            onClick={() => !readOnly && handleSelect(item.id)}
          >
            <Chip
              sx={isSelected ? selectedStyle : {}}
              label={
                <Box display="flex" alignItems="center" gap={1}>
                  <Typography variant="body2" component="span">
                    {`${item.name} - `}
                  </Typography>
                  <Typography
                    variant="body2"
                    component="span"
                    sx={{ fontWeight: 'bold' }}
                  >
                    {item.count}
                  </Typography>
                </Box>
              }
            />
          </Box>
        );
      })}
    </>
  );
};


export const ChipFilter = ({
  queryParamName,
  items,
  readOnly
}: BaseUrlParamsFilterProps & MetaFiltrableItemsProps) => {
  return (
    <BaseUrlParamsFilter queryParamName={queryParamName} defaultValue="">
      <Field
        fullWidth
        name={queryParamName}
        component={MetaFiltrableItems}
        items={items}
        readOnly={readOnly}
        queryParamName={queryParamName}
      />
    </BaseUrlParamsFilter>
  );
};
